import { useCallback, useEffect, useState } from "react";
import { Alert, FormControlLabel, Paper, Stack, Switch, Typography } from "@mui/material";

import { hostConfig } from "@lopie/kernel-ui";

export default function ScoringPanel({ token }) {
  const [state, setState] = useState(null);
  const [failure, setFailure] = useState(null);
  const conf = hostConfig();
  const ownApi = conf?.appTxnRiskApi || "";

  const own = useCallback(
    async (path, init) => {
      const r = await fetch(ownApi + path, {
        ...init,
        headers: {
          Authorization: `Bearer ${token}`,
          "content-type": "application/json",
          ...(init?.headers || {}),
        },
      });
      const text = await r.text();
      let body = null;
      try {
        body = JSON.parse(text);
      } catch {
        body = null;
      }
      if (!r.ok) throw Object.assign(new Error("refused"), { status: r.status, body });
      return body;
    },
    [ownApi, token],
  );

  const load = useCallback(async () => {
    try {
      setState(await own("/takeover"));
      setFailure(null);
    } catch (e) {
      setFailure(e);
    }
  }, [own]);

  useEffect(() => {
    load();
  }, [load]);

  async function toggle(enabled) {
    try {
      setState(await own("/takeover", { method: "PUT", body: JSON.stringify({ enabled }) }));
    } catch (e) {
      setFailure(e);
    }
  }

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={1}>
        <FormControlLabel
          control={
            <Switch
              checked={Boolean(state?.enabled)}
              disabled={!state}
              onChange={(e) => toggle(e.target.checked)}
              slotProps={{ input: { "aria-label": "score new transactions automatically" } }}
            />
          }
          label={state?.enabled ? "Auto-scoring is on" : "Auto-scoring is off"}
        />
        <Typography variant="body2" color="text.secondary">
          While this is on, the scoring agent runs once an hour on its own, as
          this app and only within what its manifest allows. A new
          transaction can sit unscored for up to an hour; use &quot;Run
          scoring now&quot; above for an immediate pass.
        </Typography>
        {failure ? (
          <Alert severity="error" variant="outlined">
            The switch could not be {state ? "changed" : "read"}.
          </Alert>
        ) : null}
      </Stack>
    </Paper>
  );
}
